const o = /* @__PURE__ */ new Set();
function a(r, e) {
  const n = `[naive/${r}]: ${e}`;
  o.has(n) || (o.add(n), console.error(n));
}
function s(r, e) {
  console.error(`[naive/${r}]: ${e}`);
}
function t(r, e) {
  throw new Error(`[naive/${r}]: ${e}`);
}
export {
  t as throwError,
  s as warn,
  a as warnOnce
};
